import { render, staticRenderFns } from "./product_3_xxw.vue?vue&type=template&id=c92a455e&scoped=true"
import script from "./product_3_xxw.vue?vue&type=script&lang=js"
export * from "./product_3_xxw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a455e",
  null
  
)

export default component.exports